import { DefaultToneDto } from "../../dto/deafulttone/defaulttonedto";
import { APIRequest, APIRequestDtoImpl } from "../apiRequest";

export interface DefaultToneRequest extends APIRequest
{
    getDefaultToneRequest(): DefaultToneDto;
}

export class DefaultToneRequestImpl extends APIRequestDtoImpl implements DefaultToneRequest
{
    constructor(private defaultToneData: DefaultToneDto)
    {
        super();
    }

    getDefaultToneRequest(): DefaultToneDto
    {
        return this.defaultToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/defaulttone/defaulttonerequest.ts